import { Component, OnInit, Input } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { RiderVehicleTypeEnum } from 'app/models';
import { ConfigService, DashboardService, AppDataService } from 'app/services';
import moment from 'moment';
import { Utils } from 'app/utils';

@Component({
    selector: 'finance-dashboard',
    templateUrl: './finance-dashboard.component.html',
    styleUrls: ['./finance-dashboard.component.scss'],
    providers: [MessageService]
})
export class FinanceDashboardComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    public vehicleTypes: any[] = [
        { label: 'All Type', value: RiderVehicleTypeEnum.None },
        { label: 'Moto', value: RiderVehicleTypeEnum.Moto },
        { label: 'Car', value: RiderVehicleTypeEnum.Sedan },
        { label: 'SUV', value: RiderVehicleTypeEnum.SUV }
    ];

    public financeDashboard: any = {};
    public selectedDateRange: Date[] = [new Date(), new Date()];

    public totalRevenueChartData: any;
    public totalRevenueChartOptions: any;

    public totalProfitChartData: any;
    public totalProfitChartOptions: any;

    public totalMonthRevenueChartData: any;
    public totalMonthRevenueChartOptions: any;

    public avgChartData: any;
    public avgChartOptions: any;
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_finance' }, { label: 'Finances' }, { label: 'Dashboard' }];

    constructor(public configService: ConfigService,
        public dashboardService: DashboardService,
        public messageService: MessageService,
        public appData: AppDataService) { }

    ngOnInit(): void {
        this.selectedDateRange[0].setDate(new Date().getDate() - 7);
        this.getTransactionDashboard();
    }

    public handleChangeDateRange() {
        if (!this.selectedDateRange[1]) {
            return;
        }
        this.getTransactionDashboard();
    }

    public getTransactionDashboard() {
        const dto = {
            StartDate: moment(this.selectedDateRange[0]).format('YYYY-MM-DD'),
            EndDate: moment(this.selectedDateRange[1]).format('YYYY-MM-DD'),
            ClientLocationType: this.appData.getClientLocationType(),
            TimeZoneOffset: Utils.getTimezoneOffset()
        };

        this.dashboardService.getTransactionDashboard(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.financeDashboard = data;
                this.financeDashboard.TotalRevenue = `₱ ${this.financeDashboard.TotalRevenue.toFixed(2)}`;
                this.financeDashboard.TotalProfit = `₱ ${this.financeDashboard.TotalProfit.toFixed(2)}`;
                this.financeDashboard.TotalMonth = `₱ ${this.financeDashboard.TotalMonth.toFixed(2)}`;
                this.financeDashboard.TotalAvgSpendUser = `₱ ${this.financeDashboard.TotalAvgSpendUser.toFixed(2)}`;
                this.financeDashboard.TotalAvgTransactionValue = `₱ ${this.financeDashboard.TotalAvgTransactionValue.toFixed(2)}`;

                if (this.financeDashboard.TotalMonthData) {
                    this.financeDashboard.TotalMonthData.map((item: any) => {
                        item = item.toFixed(2);
                        return item;
                    });
                }

                this.totalRevenueChartInit();
                this.totalPrfitChartInit();
                this.totalMonthRevenueChartInit();
                this.avgChartInit();
            });

    }

    public totalRevenueChartInit(): void {
        this.totalRevenueChartData = {
            labels: this.financeDashboard.TotalRevenueLabels,
            datasets: [
                {
                    data: this.financeDashboard.TotalRevenueData,
                    fill: true,
                    borderColor: '#FFB100',
                    tension: .4,
                    backgroundColor: 'rgba(255,177,0,0.2)'
                }
            ]
        };

        this.totalRevenueChartOptions = {
            plugins: {
                legend: {
                    display: false
                }
            }
        };
    }

    public totalPrfitChartInit(): void {
        this.totalProfitChartData = {
            labels: this.financeDashboard.TotalProfitLabels,
            datasets: [
                {
                    data: this.financeDashboard.TotalProfitData,
                    fill: true,
                    borderColor: '#66c6ea',
                    tension: .4,
                    backgroundColor: 'rgba(39, 135, 245, 0.28)'
                }
            ]
        };

        this.totalProfitChartOptions = {
            plugins: {
                legend: {
                    display: false
                }
            }
        };
    }

    public totalMonthRevenueChartInit(): void {
        this.totalMonthRevenueChartData = {
            labels: this.financeDashboard.TotalMonthLabels,
            datasets: [
                {
                    type: 'bar',
                    data: this.financeDashboard.TotalMonthData,
                    fill: true,
                    borderColor: '#183f5d',
                    tension: .4,
                    backgroundColor: 'rgba(60, 74, 89, 1)'
                }
            ]
        };

        this.totalMonthRevenueChartOptions = {
            plugins: {
                legend: {
                    display: false
                }
            }
        };
    }

    public avgChartInit(): void {
        this.avgChartData = {
            labels: this.financeDashboard.TotalAvgSpendUserLabels,
            datasets: [
                {
                    type: 'bar',
                    data: this.financeDashboard.TotalAvgSpendUserData,
                    label: 'Avg Spend per User',
                    borderColor: '#FFB100',
                    backgroundColor: '#ffb100'
                },
                {
                    type: 'line',
                    data: this.financeDashboard.TotalAvgTransactionValueData,
                    label: 'Avg Transaction value (Active Partners)',
                    borderColor: '#ff7b7b',
                    backgroundColor: '#eb4236'
                }
            ]
        };

        this.avgChartOptions = {
            plugins: {
                legend: {
                    position: 'bottom',
                    labels: {
                        color: '#333333',
                        usePointStyle: true
                    },
                    reverse: true
                },
            },
            scales: {
                x: {
                    stacked: true
                },
                y: {
                    stacked: true
                }
            }
        };
    }
}
